export const jwt = [
  {
    name: 'Index',
    url: '/jwt',
    icon: 'icon-home'
  },
  {
    name: 'Create',
    url: '/jwt/create',
    icon: 'icon-plus'
  },
  {
    name: 'Signature',
    url: '/jwt/create',
    icon: 'icon-link'
  }
];
